export const NOTE_STRINGS = ["C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B"];
export const OCTAVE_COLORS = [
    [121, 85, 72],
    [158, 158, 158],
    [96, 125, 139],
    [76, 175, 80],
    [244, 67, 54],
    [33, 150, 243],
    [0, 150, 136],
    [255, 235, 59],
    [0, 188, 212],
];
